<template>
    <div>
        <v-row dense>
            <v-col cols="12" md="6">
                <v-text-field label="Datum" type="date" v-model="form.date" @change="recomputeLot" />
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" md="6">
                <search-supplier outlined :no-results="false" :searchString="supplierSearch"
                    @setSearchString="val => supplierSearch = val" @get-results="onSupplierSelected"
                    @clear-input="clearSupplierField" />
                <div v-if="form.supplierNumber" class="mt-2">
                    Geselecteerde leverancier: {{ form.supplierNumber }}
                </div>
            </v-col>
            <v-col cols="12" md="6">
                <search-item outlined :no-results="false" :searchString="itemSearch"
                    @setSearchString="val => itemSearch = val" @get-results="onItemSelected"
                    @clear-input="clearItemField" />
                <div v-if="form.item">
                    Geselecteerd artikel: {{ form.item.name }} ({{ form.item.itemNumber }})
                </div>
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" md="6">
                <v-select :items="countryItems" item-text="cname" item-value="ccode" label="Gehouden in"
                    v-model="form.heldCountry" />
            </v-col>
            <v-col cols="12" md="6">
                <v-select :items="countryItems" item-text="cname" item-value="ccode" label="Geslacht in"
                    v-model="form.slaughterCountry" />
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" md="6">
                <v-text-field label="Documentnummer leverancier" v-model="form.docNumber" @input="recomputeLot" />
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field label="Lot/batchnummer op document" v-model="form.supplierItemLotNumber"
                    @input="recomputeLot" />
            </v-col>
        </v-row>


        <v-row dense>
            <v-col cols="12" md="8">
                <v-alert type="info" v-if="previewLotNumber">
                    Voorbeeld lotnummer: <b>{{ previewLotNumber }}</b>
                </v-alert>
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12">
                <v-btn color="primary" :disabled="!canSubmit" @click="submit">
                    Toevoegen aan beschikbare lotnummers
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="activeLots.length" dense>
            <v-col cols="12" class="d-flex justify-space-between align-center">
                <h3>Actieve (niet gearchiveerde) lotnummers voor artikel</h3>
                <v-btn small color="error" @click="archiveAll">Archiveer alles</v-btn>
            </v-col>
            <v-col cols="12">
                <v-data-table :headers="activeLotHeaders" :items="activeLots" :items-per-page="10">
                    <template v-slot:[`item.date`]="{ item }">
                        {{ toDateString(item.date) }}
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-btn small color="error" @click="archiveOne(item)">Archiveer</v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-row dense class="mt-6">
            <v-col cols="12" md="6">
                <v-text-field label="Zoek geclaimd lotnummer (exact)" v-model="searchLot"
                    @keyup.enter="searchClaimedLots" />
            </v-col>
            <v-col cols="12" md="2" class="d-flex align-center">
                <v-btn color="primary" @click="searchClaimedLots">Zoeken</v-btn>
            </v-col>
        </v-row>
        <v-row v-if="lotResults.length" dense>
            <v-col cols="12">
                <v-data-table :headers="lotHeaders" :items="lotResults" :items-per-page="10">
                    <template v-slot:[`item.date`]="{ item }">
                        {{ toDateString(item.date) }}
                    </template>
                    <template v-slot:[`item.claimedAt`]="{ item }">
                        {{ toDateString(item.claimedAt) }}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row dense class="mt-6">
            <v-col cols="12" md="6" class="d-flex align-center">
                <v-btn color="primary" @click="openDailyLots">Dagrapport PDF</v-btn>
                <v-btn class="ml-2" color="primary" @click="downloadDailyLots">Download PDF</v-btn>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import searchItem from "../components/searchItem.vue"
import searchSupplier from "../components/searchSupplier.vue"
import { fetchPOST, fetchGET, successHandler, errorHandler, toDateString } from "../js/functions"
import { countries } from "../js/countries"
import { buildLotNumber } from "../js/traceability"
import { viewDailyLots } from "../js/pdfController"

export default {
    name: "traceability",
    components: { searchItem, searchSupplier },
    data() {
        return {
            supplierSearch: "",
            itemSearch: "",
            searchLot: "",
            form: {
                date: new Date().toISOString().split("T")[0],
                supplierNumber: "",
                item: null,
                heldCountry: "",
                slaughterCountry: "",
                docNumber: "",
                supplierItemLotNumber: "",
            },
            previewLotNumber: "",
            lotResults: [],
            lotHeaders: [
                { text: "Lotnummer", value: "finalLotNumber" },
                { text: "Artikelnr", value: "itemNumber" },
                { text: "Artikel", value: "name" },
                { text: "Datum", value: "date" },
                { text: "Geclaimd op", value: "claimedAt" },
                { text: "Leveranciernr", value: "supplierNumber" },
                { text: "Documentnr", value: "docNumber" },
                { text: "Batchnr", value: "supplierItemLotNumber" },
                { text: "Gehouden in", value: "heldCountry" },
                { text: "Geslacht in", value: "slaughterCountry" },
            ],
            activeLots: [],
            activeLotHeaders: [
                { text: "Lotnummer", value: "finalLotNumber" },
                { text: "Leverancier", value: "supplierName" },
                { text: "Leveranciernr", value: "supplierNumber" },
                { text: "Datum", value: "date" },
                { text: "Gehouden in", value: "heldCountry" },
                { text: "Geslacht in", value: "slaughterCountry" },
                { text: "", value: "actions", sortable: false },
            ],
        }
    },
    computed: {
        countryItems() {
            const allowed = ["DE", "NL", "FR", "BE", "PL"]
            // enforce order as requested
            const byCode = new Map(countries.map(c => [c.ccode, c]))
            return allowed.map(code => byCode.get(code) || { ccode: code, cname: code })
        },
        canSubmit() {
            return (
                this.form.date &&
                this.form.supplierNumber &&
                this.form.item &&
                this.form.docNumber &&
                this.form.supplierItemLotNumber
            )
        }
    },
    methods: {
        toDateString(date) {
            return toDateString(date)
        },
        onSupplierSelected(supplier) {
            this.form.supplierNumber = (supplier && supplier.supplierNumber) || ""
            this.recomputeLot()
        },
        onItemSelected(item) {
            this.form.item = item
            this.recomputeLot()
            this.fetchActiveLots()
        },
        clearSupplierField() {
            this.form.supplierNumber = ""
            this.supplierSearch = ""
            this.recomputeLot()
        },
        clearItemField() {
            this.form.item = null
            this.itemSearch = ""
            this.previewLotNumber = ""
            this.activeLots = []
        },
        async fetchActiveLots() {
            try {
                if (!this.form.item) {
                    this.activeLots = []
                    return
                }
                // fetch full item to get its availableLotNumbers (backend expects a scalar, not an object)
                const full = await fetchGET("findItem", this.form.item.itemNumber)
                const lots = (full && Array.isArray(full.availableLotNumbers)) ? full.availableLotNumbers : []
                this.activeLots = lots.filter(l => !l.archived)
            } catch (e) {
                this.activeLots = []
            }
        },
        async archiveOne(lot) {
            try {
                await fetchPOST("archiveAvailableLotNumber", { itemId: this.form.item._id, lotId: lot.id })
                this.activeLots = this.activeLots.filter(l => l.id !== lot.id)
                successHandler("Lot gearchiveerd")
            } catch (e) {
                errorHandler(e, "Archiveren mislukt")
            }
        },
        async archiveAll() {
            try {
                if (!this.form.item) return
                await fetchPOST("archiveAllAvailableLotNumbers", { itemId: this.form.item._id })
                this.activeLots = []
                successHandler("Alle lotnummers gearchiveerd")
            } catch (e) {
                errorHandler(e, "Alles archiveren mislukt")
            }
        },
        async searchClaimedLots() {
            try {
                const raw = (this.searchLot || "").trim()
                if (!raw) {
                    this.lotResults = []
                    return
                }
                const res = await fetchGET("searchClaimedLots", { lotNumber: raw })
                this.lotResults = Array.isArray(res) ? res : []
            } catch (e) {
                errorHandler(e, "Zoeken mislukt")
            }
        },
        async openDailyLots() {
            try {
                const lots = await fetchGET("fetchDailyCreatedLots", { date: this.form.date, includeArchived: true })
                if (!Array.isArray(lots) || lots.length === 0) {
                    return successHandler("Geen lotnummers voor deze dag")
                }
                const blob = await viewDailyLots(this.form.date, lots, {})
                const url = URL.createObjectURL(blob)
                window.open(url, "_blank")
            } catch (e) {
                errorHandler(e, "Dagrapport mislukt")
            }
        },
        async downloadDailyLots() {
            try {
                const lots = await fetchGET("fetchDailyCreatedLots", { date: this.form.date, includeArchived: true })
                if (!Array.isArray(lots) || lots.length === 0) {
                    return successHandler("Geen lotnummers voor deze dag")
                }
                const blob = await viewDailyLots(this.form.date, lots, {})
                const url = URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = url
                a.download = `Dagrapport-lots-${this.form.date}.pdf`
                document.body.appendChild(a)
                a.click()
                a.remove()
                URL.revokeObjectURL(url)
            } catch (e) {
                errorHandler(e, "Download mislukt")
            }
        },
        recomputeLot() {
            if (
                this.form.supplierNumber &&
                this.form.item && this.form.item.itemNumber != null &&
                (this.form.docNumber || this.form.supplierItemLotNumber)
            ) {
                this.previewLotNumber = buildLotNumber(
                    this.form.supplierNumber,
                    this.form.item.itemNumber,
                    this.form.docNumber,
                    this.form.supplierItemLotNumber
                )
            } else {
                this.previewLotNumber = ""
            }
        },
        async submit() {
            try {
                const payload = {
                    itemId: this.form.item._id,
                    supplierNumber: this.form.supplierNumber,
                    docNumber: this.form.docNumber,
                    supplierItemLotNumber: this.form.supplierItemLotNumber,
                    date: this.form.date,
                    heldCountry: this.form.heldCountry || undefined,
                    slaughterCountry: this.form.slaughterCountry || undefined,
                }
                await fetchPOST("addAvailableLotNumberToItem", payload)
                successHandler("Lotnummer toegevoegd")
                // reset doc fields, keep supplier/item for fast entry
                this.form.docNumber = ""
                this.form.supplierItemLotNumber = ""
                this.previewLotNumber = ""
                // refresh active lots list
                this.fetchActiveLots()
            } catch (e) {
                errorHandler(e, "Kon lotnummer niet toevoegen")
            }
        },
    },
}
</script>
<style scoped></style>
